// @flow
import { TITLE_AND_TEXT } from 'Client/cms/toolkit/constants';
import { TitleAndTextLine } from 'Components/lines/title-and-text-line/TitleAndTextLine.jsx';
import { titleAndTextResolver } from './titleAndText.resolver';

export const titleAndTextDescriptor = {
  name: TITLE_AND_TEXT,
  component: TitleAndTextLine,
  resolve: titleAndTextResolver.resolve,
};
